<template>
  <div class="md-layout text-center md-alignment-center-center" style="min-height: 100vh;">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card header-color="green">
        <img slot="logo" src="img/logo-black.png" style="border-radius: unset">
        <h4 slot="title" class="title"></h4>
        <p slot="description" class="description">Sign in to Partner Zone</p>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email" @keydown.native.enter="submit"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input v-model="password" type="password" @keydown.native.enter="submit"></md-input>
        </md-field>
        <div slot="footer">
          <md-button slot="footer" class="md-simple md-success md-lg" v-on:click="submit">
            Continue
          </md-button>
          <md-button class="md-simple md-warning md-lg" v-on:click="forgotPassword">
            Forgot password?
          </md-button>
          <md-button class="md-simple md-warning md-lg" v-on:click="signup">
            Signup
          </md-button>
        </div>
      </login-card>
    </div>
  </div>
</template>
<script>

import {LoginCard} from '@/components'
import AuthService from "@/services/AuthService";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      email: null,
      password: null
    }
  },
  methods: {
    submit() {
      AuthService.GetAccessToken(this.email, this.password)
        .then(() => {this.$router.push('/'); window.location.reload()})
        .catch((error => console.log(error)));
    },
    forgotPassword() {
      this.$router.push('forgotpassword');
    },
    signup() {
      this.$router.push('signup');
    }
  }
}
</script>

<style>
</style>
